import { EChipsVariants } from 'components/atoms/Chips';
import { CaseStatus } from 'models/cases';

export enum ElabelsCaseManagement {
  caseManagementHeader = 'caseManagement.header.label',
  caseManagementDashboard = 'caseManagement.dashboard.label',
  caseManagementTasks = 'caseManagement.tasks.label',
  caseManagementCases = 'caseManagement.cases.label',
}

export const renderStatusCaseFieldColor = (props: { statusUniqueId: string }) => {
  switch (props.statusUniqueId) {
    case CaseStatus.PENDING_ALLOCATION:
      return EChipsVariants.warning;
    case CaseStatus.IN_PROGRESS:
      return EChipsVariants.primary;
    case CaseStatus.SUPERVISOR_REVIEW:
      return EChipsVariants.primary;
    case CaseStatus.GRANTED:
      return EChipsVariants.success;
    case CaseStatus.REFUSED:
      return EChipsVariants.error;
    case CaseStatus.REJECTED:
      return EChipsVariants.error;
    case CaseStatus.CLOSED:
      return EChipsVariants.success;
    default:
      return EChipsVariants.warning;
  }
};
